import {
  AdminCreateUsageBillingUrlRequestBodyType,
  AdminCreateUsageBillingUrlResponseBodyType,
} from "@intelligems/ig-types/functions/shopify-app-subscriptions/admin-create-usage-billing-url";
import {
  CreateUsageBillingUrlRequestBodyType,
  CreateUsageBillingUrlResponseBodyType,
} from "@intelligems/ig-types/functions/shopify-app-subscriptions/create-usage-billing-url";
import { useMutation } from "@tanstack/react-query";

import {
  mpBillingShopifyApprovalStarted,
  type MpBillingShopifyApprovalStartedProps,
} from "@src/utils/mixpanel";

import { api } from "../api";
import { ApiRequest } from "../types/api";

// The url is a Blocking Approval handoff whichever surface asked for it, so the
// caller states what it is sending the merchant to approve and the hook
// announces it at the one moment the url is in hand.
export type CreateUsageBillingUrlVariables =
  ApiRequest<CreateUsageBillingUrlRequestBodyType> & {
    analytics: MpBillingShopifyApprovalStartedProps;
  };

const createUsageBillingUrl = async (
  data: ApiRequest<CreateUsageBillingUrlRequestBodyType>
) => {
  const resp = await api.post<CreateUsageBillingUrlResponseBodyType>(
    "/v2/usage-billing-url",
    data.body
  );
  return resp.data;
};

export const useCreateUsageBillingUrl = () => {
  return useMutation<
    CreateUsageBillingUrlResponseBodyType,
    Error,
    CreateUsageBillingUrlVariables,
    any
  >({
    mutationKey: ["request-billing-url"],
    mutationFn: async (data) => createUsageBillingUrl(data),
    onSuccess: (data, variables) => {
      // The response states the url as optional, so a success with none is a
      // real outcome: the merchant never leaves, and announcing a handoff or
      // opening a blank tab would both be wrong.
      if (!data.billingUrl) {
        return;
      }
      mpBillingShopifyApprovalStarted(variables.analytics);
      window.open(data.billingUrl, "_blank");
    },
  });
};
